import {
  Image,
  Text,
  View,
} from "@react-pdf/renderer";
import React from "react";
import email from "../../assets/icons/email.png";
import location from "../../assets/icons/location.png";
import call from "../../assets/icons/phone.png";
import Logo from "../../assets/image/logo512.png";

import { fonts, reportStyles } from "./report-style";
fonts();
const ReportHeader = ({ organizationInfo }) => (
  <View >
  <View style={reportStyles.pdfHeader} >
    <View style={reportStyles.PdfLogo}>
        <Image
          src={organizationInfo?.logo ? `data:image/png;base64,${organizationInfo.base64logo}` : Logo}
          alt="Logo"
          style={reportStyles.Logo}
        />
    </View>
    <View style={reportStyles.HeaderDescription}>
      {organizationInfo?.org_name && (
        <>
          <Text style={reportStyles.HeaderHeading}>{organizationInfo?.org_name}</Text>
          {/* <Text>{organizationInfo.path}{organizationInfo.logo}</Text> */}
        </>
      )}
      {(organizationInfo?.address || organizationInfo?.locality || organizationInfo?.landmark ||
        organizationInfo?.city || organizationInfo?.state || organizationInfo?.country || organizationInfo?.pincode) && (
          <View style={[reportStyles.HeaderLocation, { marginBottom: "10px" }]}>
            <Image src={location} alt="location" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
            <Text>
              {organizationInfo?.address ? organizationInfo.address + ", " : ""}
              {organizationInfo?.locality ? organizationInfo.locality + ", " : ""}
              {organizationInfo?.landmark ? organizationInfo.landmark + ", " : ""}
              {organizationInfo?.city ? organizationInfo.city + ", " : ""}
              {organizationInfo?.state ? organizationInfo.state + ", " : ""}
              {organizationInfo?.country ? organizationInfo.country + " " : ""}
              {organizationInfo?.pincode ? organizationInfo.pincode : ""}
            </Text>
          </View>
        )}

      <View style={reportStyles.HeaderLocation}>
        {(organizationInfo?.phone || organizationInfo?.landline) && (
          <View style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "row" }}>
            <Image src={call} alt="call" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
            <Text>{organizationInfo?.phone || organizationInfo?.landline}</Text>
          </View>
        )}

        {organizationInfo?.email && (
          <View style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "row" }}>
            <Image src={email} alt="email" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
            <Text>{organizationInfo?.email}</Text>
          </View>
        )}
      </View>
    </View>
  </View>
  <View style={reportStyles.gap}/>

  </View>
  

);

export default ReportHeader;
